export function ignoreSelfSignedCertErrors({ reporter }) {
    if (typeof process !== 'undefined') {
        // When using self-signed certificates for the api server, node fails to make requests unless we set this.
        // eslint-disable-next-line no-restricted-properties -- ok to set properties
        process.env.NODE_TLS_REJECT_UNAUTHORIZED = '0';
        // When we do this, node creates a console.error that we need to ignore:
        //
        // (node:26988) Warning: Setting the NODE_TLS_REJECT_UNAUTHORIZED environment variable to '0'
        // makes TLS connections and HTTPS requests insecure by disabling certificate verification.
        reporter?.ignoreLogMessage('Warning: Setting the NODE_TLS_REJECT_UNAUTHORIZED environment variable');
    }
}
//# sourceMappingURL=ignoreSelfSignedCertErrors.js.map